import { fabric } from 'fabric';

export const type = 'group-base';

/**
 * GroupBase is a simple subclass of fabric.Group that has some common defaults.
 */
const GroupBase = fabric.util.createClass(fabric.Group, {
  id: '',
  towerCard: undefined,
  type,
  borderColor: 'purple',
  cornerColor: 'purple',
  cornerStyle: 'circle',
  cornerSize: 8,
  includeDefaultValues: false,

  initialize: function (objects: fabric.Object[], options: fabric.GroupBaseOptions) {
    this.callSuper('initialize', objects, options);
  },

  toObject: function (propsToInclude?: string[]) {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      ...propsToInclude,
      id: this.id,
      towerCard: this.towerCard,
      includeDefaultValues: this.includeDefaultValues,
      borderColor: this.borderColor,
      cornerColor: this.cornerColor,
      cornerStyle: this.cornerStyle,
      cornerSize: this.cornerSize,
    });
  },
});

GroupBase.fromObject = function (obj: fabric.GroupBaseOptions, fn: (obj: fabric.Object) => void) {
  // enliven the objects first with the fromObject function
  fabric.Group.fromObject(obj, function (group: fabric.Group) {
    const groupOptions = fabric.util.object.clone(obj);
    delete groupOptions.objects;

    if (fn) fn(new fabric.GroupBase(group._objects, groupOptions));
  });
};

export default GroupBase;
